export type EmusRequestType = {
  1: '客户画像agent';
  2: '客户画像额外信息agent';
  3: '持仓诊断agent';
  4: '资产配置agent';
  8: '产品信息-产品推荐agent';
  9: '产品信息-产品对比agent';
  10: '产品信息-产品解读agent';
  11: '投顾洞察-市场解读agent';
  16: '趋势走向';
  17: '市场分析';
};

// 运行时映射对象，用于根据 reqType 获取对应的名称
export const EmusRequestTypeMap: Record<
  keyof EmusRequestType,
  EmusRequestType[keyof EmusRequestType]
> = {
  1: '客户画像agent',
  2: '客户画像额外信息agent',
  3: '持仓诊断agent',
  4: '资产配置agent',
  8: '产品信息-产品推荐agent',
  9: '产品信息-产品对比agent',
  10: '产品信息-产品解读agent',
  11: '投顾洞察-市场解读agent',
  16: '趋势走向',
  17: '市场分析'
};
